import { useContext } from "react";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import moment from "moment";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { useSnackbar } from "../../../../context/SnackbarContext";
import AddContactSelector from "../../../common/AddContactSelector";
import UBDateSelect from "../../../../Libraries/UBDateSelect";
import {
  getPendingCollectionStatus,
  PENDING_STATUS,
} from "./pendingPaymentStatusUtils";
import styles from "./PendingPaymentCollection.module.css";
import { camelCase, sentenceCase } from "../../../../constants";

const ItemList = ({ detail, onCollectionDateUpdated }) => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const status = getPendingCollectionStatus(detail?.collect_at, I18n);

  const handleCollect = (e) => {
    e.stopPropagation();
    triggerLogEvent(analytics, "w_payments_req");
    navigate("/UCash/RequestMoney", { state: detail._raw || detail });
  };

  const handleApplyCollectionDate = async (date) => {
    if (!date) return;
    triggerLogEvent(analytics, "w_payments_set_collection_date");
    const dateObj = date?.toDate ? date.toDate() : new Date(date);
    dateObj.setHours(0, 0, 0, 0);
    try {
      await detail.updateCollectionDate(dateObj);
      onCollectionDateUpdated?.();
      showSnackbar({
        message: I18n.collection_date_set,
        severity: "success",
      });
    } catch (error) {
      showSnackbar({
        message: I18n.something_went_wrong || "Something went wrong",
        severity: "error",
      });
    }
  };

  const statusClassName =
    status.type === PENDING_STATUS.DUE_TODAY
      ? styles.statusDueToday
      : status.type === PENDING_STATUS.DUE_TOMORROW
        ? styles.statusDueTomorrow
        : status.type === PENDING_STATUS.SET_DATE
          ? styles.statusSetDate
          : status.type === PENDING_STATUS.NONE
            ? styles.statusDate
            : styles.statusPending;

  return (
    <Box
      id={`pending_payment_row_${detail?.id}`}
      className="invoiceListTableBody accountTableHeaderMain pointer"
      onClick={() => navigate(`/Accounts/AccountDetail/${detail?.id}`, { state: { backTo: "/UCash/PendingPaymentCollection" } })}
    >
      

      <Box className={`invListTableHeaderCol fiveColumn textLeft ${styles.pendingContactCell}`} style={{ pointerEvents: "none" }}>
        <AddContactSelector
          selectedContact={
            detail?.name ? { id: detail.id, name: detail.name } : null
          }
          contacts={[]}
          isOpen={false}
          onOpenChange={() => {}}
        />
      </Box>

      <Box className="invListTableHeaderCol fiveColumn textLeft">
        {status.type === PENDING_STATUS.SET_DATE ? (
          <Box
            className={styles.collectionDateSelect}
            onClick={(e) => e.stopPropagation()}
          >
            <UBDateSelect
              id={`collection_date_${detail?.id}`}
              title={sentenceCase(I18n.set_collection_date)}
              placeholder={sentenceCase(I18n.set_collection_date)}
              selectedDate={null}
              setSelectedDate={handleApplyCollectionDate}
              disablePast
              placeholderColor="barclayBlueColor"
            />
          </Box>
        ) : (
          <ParagraphText className={statusClassName}>{status.label}</ParagraphText>
        )}
      </Box>
      <Box className="invListTableHeaderCol fiveColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine newFontColor">
          {detail?.last_transaction_at
            ? moment(detail.last_transaction_at).format("DD MMM YYYY")
            : "-"}
        </ParagraphText>
      </Box>

      <Box className="invListTableHeaderCol fiveColumn textRight">
        <ParagraphText className={styles.pendingAmount}>
          Rs. {formatNum(detail?.total_outstanding_payment)}
        </ParagraphText>
      </Box>

      <Box className={`invListTableHeaderCol fiveColumn justifyCenter ${styles.actionsCell}`}>
        <UBButton
          title={I18n.collect}
          id={`CollectButton-${detail?.id}`}
          onClick={handleCollect}
          className={`${styles.collectBtn} textUppercase`}
        />
      </Box>
    </Box>
  );
};

export default ItemList;
